<template>
	<div>
		<case-form :schema="schemaInsured" />

		<case-form :schema="schemaInsuredRelationship" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalInsureds",
	components: { CaseForm },
	computed: {
		schemaInsured() {
			return [
				{
					label: "Select Insured Premises",
					component: "entitySelect",
					bindTo: "case.insureds[0]",
					entity: "case.insureds[0]",
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				{
					label: "Insured Premises Address",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0AddressId",
					props: {
						suggest: {
							typeIncludes: "main"
						},
						createOptions: {
							type: "main"
						}
					}
				},
				// {
				// 	label: "1. (c) State the floor on which your premises are situated:",
				// 	component: "entityFact",
				// 	entity: "case.insureds[0]",
				// 	relation: "case.insureds[0].facts",
				// 	bindTo: "case.facts.insured0PremisesFloorId"
				// },
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>1. (d) How long have you carried on business?</div>"
					},
					bindTo: ""
				},
				{
					label: "In these premises",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0BusinessOperationInPremisesId",
					props: {
						suggest: {
							typeIncludes: "businessOperationInPremisesDuration"
						},
						createOptions: {
							type: "businessOperationInPremisesDuration",
							dataType: "string"
						}
					}
				},
				{
					label: "Elsewhere",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0BusinessOperationElsewhereId",
					props: {
						suggest: {
							typeIncludes: "businessOperationElsewhereDuration"
						},
						createOptions: {
							type: "businessOperationElsewhereDuration",
							dataType: "string"
						}
					}
				}
			]
		},

		schemaInsuredRelationship() {
			return [
				{
					label: "Manage Relationship of Insured and Policyholder",
					component: "entityRelationship",
					entity: "case.holder",
					relation: "case.holder.relationships",
					bindTo: "case.facts.insured0RelationshipId"
				}
			]
		}
	}
}
</script>
